<template>
  <el-container v-title data-title="批量操作" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>人员管理</el-breadcrumb-item>
                <el-breadcrumb-item>批量操作</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form ref="addForm" :inline="true" :model="addData" :rules="rules" class="demo-form-inline" >
                <el-form-item label="操作类型" :required="true" prop="type">
                  <!-- <el-select v-model="addData.type" placeholder="请选择" @change="handleSearch"> -->
                  <el-select v-model="addData.type" placeholder="请选择">
                    <el-option label="批量新增教职员" value="1"></el-option>
                    <el-option label="批量修改教职员" value="2"></el-option>
                    <el-option label="批量新增学生" value="3"></el-option>
                    <el-option label="批量修改学生" value="4"></el-option>
                    <el-option label="教职员是否存在" value="5"></el-option>
                    <el-option label="学生是否存在" value="6"></el-option>
                  </el-select>
                </el-form-item>
                <el-link href="/static/批量操作模板.xlsx">
                  <el-button type="success" plain>下载模板</el-button>
                </el-link>
                <br>
                <el-form-item label="内容编排" :required="true" prop="content" class="messageContentBox">
                  <el-input type="textarea" :rows="5" placeholder="请输入" v-model="addData.content"></el-input>
                </el-form-item>
                <br>
                <el-form-item>
                  <el-button type="primary" @click="batchOperate">确定</el-button>
                </el-form-item>
              </el-form>
              <br>
              <el-table :data="formatData" border stripe>
                <el-table-column prop="lineNo" label="序号" width="50"></el-table-column>
                <el-table-column prop="schoolName" label="学校" width="120"></el-table-column>
                <el-table-column v-if="['3', '4', '6'].indexOf(addData.type) != -1" prop="className" label="班级" width="120"></el-table-column>
                <el-table-column prop="realName" label="姓名" width="130"></el-table-column>
                <el-table-column v-if="['1', '2', '5'].indexOf(addData.type) != -1" prop="mobile" label="手机号码" width="120"></el-table-column>
                <el-table-column v-if="['1', '2', '5'].indexOf(addData.type) != -1" prop="isFacultyAdminName" label="教职管理员" width="110"></el-table-column>
                <el-table-column v-if="['1', '2', '5'].indexOf(addData.type) != -1" prop="classNames" label="班级列表" width="120"></el-table-column>
                <el-table-column v-if="['1', '2', '5'].indexOf(addData.type) != -1" prop="allowEditClassNames" label="班主任班级列表" width="120"></el-table-column>
                <el-table-column v-if="['3', '4', '6'].indexOf(addData.type) != -1" prop="parentMobile1" label="家长手机号码1" width="120"></el-table-column>
                <el-table-column v-if="['3', '4', '6'].indexOf(addData.type) != -1" prop="parentMobile2" label="家长手机号码2" width="120"></el-table-column>
                <el-table-column prop="idCardNo" label="身份证号码" width="200"></el-table-column>
                <el-table-column prop="cardNo" label="卡号" width="120"></el-table-column>
                <el-table-column v-if="['3', '4', '6'].indexOf(addData.type) != -1" prop="expiredTimeStr" label="到期时间" width="80"></el-table-column>
                <el-table-column prop="genderName" label="性别" width="50"></el-table-column>
                <el-table-column prop="no" :label="['1', '2', '5'].indexOf(addData.type) != -1 ? '工号' : '学号'" width="120"></el-table-column>
                <el-table-column v-if="['3', '4', '6'].indexOf(addData.type) != -1" prop="studentTypeName" label="学生类型" width="80"></el-table-column>
                <el-table-column v-if="['3', '4', '6'].indexOf(addData.type) != -1" prop="isBoarderName" label="是否住校" width="80"></el-table-column>
              </el-table>
            </el-main>
          </el-container>
        </el-header>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      addData: {
        content: ''
      },
      rules: {
        type: [{ required: true, message: '请输入内容编排', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容编排', trigger: 'blur' }]
      },
      textarea: ''
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
    }
  },
  computed: {
    formatData () {
      let tempArray = []
      if (this.addData.content != null) {
        let lines = this.addData.content.split('\n')
        switch (this.addData.type) {
          case '1':
          case '2':
          case '5': {
            let titleArray = []
            for (let line = 0; line < lines.length; line++) {
              // console.log('lines[line]: ' + lines[line])
              if (lines[line] != null && lines[line].length > 1) {
                let tempLine = {}
                let columns = lines[line].split('\t')
                if (columns.length < 3) break
                if (line === 0) {
                  for (let column = 0; column < columns.length; column++) {
                    if (['学校', '姓名', '手机号码', '教职管理员', '班级列表', '班主任班级列表', '身份证号码', '卡号', '性别', '工号'].indexOf(columns[column]) === -1) {
                      break
                    }
                    if (column === 0) {
                      if (columns[column] === '学校') {
                        titleArray[column] = 'schoolName'
                        continue
                      } else {
                        break
                      }
                    }
                    if (column === 1) {
                      if (columns[column] === '姓名') {
                        titleArray[column] = 'realName'
                        continue
                      } else {
                        break
                      }
                    }
                    if (columns[column] === '手机号码') {
                      titleArray[column] = 'mobile'
                    } else if (columns[column] === '教职管理员') {
                      titleArray[column] = 'isFacultyAdminName'
                    } else if (columns[column] === '班级列表') {
                      titleArray[column] = 'classNames'
                    } else if (columns[column] === '班主任班级列表') {
                      titleArray[column] = 'allowEditClassNames'
                    } else if (columns[column] === '身份证号码') {
                      titleArray[column] = 'idCardNo'
                    } else if (columns[column] === '卡号') {
                      titleArray[column] = 'cardNo'
                    } else if (columns[column] === '性别') {
                      titleArray[column] = 'genderName'
                    } else if (columns[column] === '工号') {
                      titleArray[column] = 'no'
                    } else {
                      break
                    }
                  }
                  console.log('titleArray: ')
                  console.log(titleArray)
                }
                if (line > 0) {
                  for (let column = 0; column < columns.length; column++) {
                    tempLine.lineNo = line
                    tempLine[titleArray[column]] = columns[column]
                  }
                  tempArray.push(tempLine)
                }
              }
            }
            break
          }
          case '3':
          case '4':
          case '6': {
            let titleArray = []
            for (let line = 0; line < lines.length; line++) {
              console.log('lines[line]: ' + lines[line])
              if (lines[line] != null && lines[line].length > 1) {
                let tempLine = {}
                let columns = lines[line].split('\t')
                if (columns.length < 4) break
                if (line === 0) {
                  console.log(line)
                  for (let column = 0; column < columns.length; column++) {
                    if (['学校', '班级', '姓名', '家长手机号码1', '家长手机号码2', '身份证号码', '卡号', '到期时间', '性别', '学号', '学生类型', '是否住校'].indexOf(columns[column]) === -1) {
                      break
                    }
                    if (column === 0) {
                      if (columns[column] === '学校') {
                        titleArray[column] = 'schoolName'
                        continue
                      } else {
                        break
                      }
                    }
                    if (column === 1) {
                      if (columns[column] === '班级') {
                        titleArray[column] = 'className'
                        continue
                      } else {
                        break
                      }
                    }
                    if (column === 2) {
                      if (columns[column] === '姓名') {
                        titleArray[column] = 'realName'
                        continue
                      } else {
                        break
                      }
                    }
                    if (columns[column] === '家长手机号码1') {
                      titleArray[column] = 'parentMobile1'
                    } else if (columns[column] === '家长手机号码2') {
                      titleArray[column] = 'parentMobile2'
                    } else if (columns[column] === '身份证号码') {
                      titleArray[column] = 'idCardNo'
                    } else if (columns[column] === '卡号') {
                      titleArray[column] = 'cardNo'
                    } else if (columns[column] === '到期时间') {
                      titleArray[column] = 'expiredTimeStr'
                    } else if (columns[column] === '性别') {
                      titleArray[column] = 'genderName'
                    } else if (columns[column] === '学号') {
                      titleArray[column] = 'no'
                    } else if (columns[column] === '学生类型') {
                      titleArray[column] = 'studentTypeName'
                    } else if (columns[column] === '是否住校') {
                      titleArray[column] = 'isBoarderName'
                    } else {
                      break
                    }
                  }
                  console.log('titleArray: ')
                  console.log(titleArray)
                }
                if (line > 0) {
                  for (let column = 0; column < columns.length; column++) {
                    tempLine.lineNo = line
                    tempLine[titleArray[column]] = columns[column]
                  }
                  tempArray.push(tempLine)
                }
              }
            }
          }
        }
      }
      console.log(tempArray)
      return tempArray
    }
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    batchOperate () {
      console.log(this.addData)
      let _this = this
      console.log('test111111')
      console.log(_this.addData.type)
      console.log(['1', '2', '3', '4'].indexOf(_this.addData.type))
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          if (['1', '2', '3', '4'].indexOf(_this.addData.type) !== -1) {
            this.$axios.post(this.GLOBAL.host + '/user/batchOperate', {
              currentUserId: _this.userInfo.id,
              type: _this.addData.type,
              userList: _this.formatData
            }).then(res => {
              if (res.data != null) {
                if (res.data.status === 200) {
                  this.$message({
                    type: 'success',
                    message: '操作成功!'
                  })
                } else {
                  this.$message.error(res.data.message)
                }
              }
            })
          } else {
            this.$axios.post(this.GLOBAL.host + '/user/exportExistedData', {
              currentUserId: _this.userInfo.id,
              type: _this.addData.type,
              userList: _this.formatData
            }, {
              responseType: 'blob'
            }).then(res => {
              // if (res.data != null) {
              //   if (res.data.status === 200) {
              //     this.$message({
              //       type: 'success',
              //       message: '操作成功!'
              //     })
              //   } else {
              //     this.$message.error(res.data.message)
              //   }
              // }
              if (res.data != null) {
                let errorMessage = ''
                let reader = new FileReader()
                reader.onload = function () {
                  try {
                    let response = JSON.parse(reader.result)
                    if (response != null && response.message != null) {
                      errorMessage = response.message
                      console.log('errorMessage-111111')
                      console.log('errorMessage: ' + errorMessage)
                      _this.$message.error(errorMessage)
                    }
                  } catch (e) {
                    let contentDisposition = res.headers['content-disposition']
                    console.log(contentDisposition)
                    let fileName = window.decodeURI(contentDisposition.substring(contentDisposition.indexOf('=') + 1))
                    let blob = new Blob([res.data], {type: 'application/vnd.ms-excel'})
                    let url = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.download = fileName // 重命名文件
                    link.click()
                    URL.revokeObjectURL(url) // 释放内存
                  }
                }
                reader.readAsText(res.data)
              }
            })
          }
        }
      })
    }
  }
})
</script>
<style>
.messageContentBox, .messageContentBox .el-form-item__content {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/BatchOperation.vue